import { objectEntries } from '@scalar/helpers/object/object-entries';
import { getResolvedAsyncApiRef } from '../helpers/get-resolved-async-api-ref.js';
/**
 * Resolves every message defined on a channel (AsyncAPI data store for payloads).
 */
export const getAllChannelMessages = (_document, channel) => {
    if (!channel.messages) {
        return [];
    }
    return objectEntries(channel.messages)
        .map(([name, messageRef]) => {
        const message = getResolvedAsyncApiRef(messageRef);
        return { name, message };
    })
        .filter((entry) => entry.message != null);
};
